export default `/* Ids Color Component */
:host {
  overflow: visible;
  display: inline-flex;
  height: fit-content;
  width: fit-content;
  padding: 1px;
}
:host .ids-color {
  background-color: var(--ids-color-transparent);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
:host .no-color {
  border: 1px solid #bbb;
  border-radius: 2px;
  position: relative;
}
:host .no-color::before {
  transform: rotate(-45deg);
  border-top: 2px solid var(--ids-color-error-default);
  content: "";
  left: 0;
  right: 0;
  overflow: hidden;
  position: absolute;
  width: 100%;
}
:host .no-color .color-check {
  opacity: 0;
  visibility: hidden;
}
:host .transparent {
  border: 1px solid #bbb;
  border-radius: 2px;
  position: relative;
  background-image: linear-gradient(45deg, var(--ids-color-checkerboard) 25%, transparent 25%), linear-gradient(-45deg, var(--ids-color-checkerboard) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, var(--ids-color-checkerboard) 75%), linear-gradient(-45deg, transparent 75%, var(--ids-color-checkerboard) 75%);
  background-size: 8px 8px;
  background-position: 0 0, 0 4px, 4px -4px, -4px 0;
}
:host .transparent .color-check {
  opacity: 0;
  visibility: hidden;
}
:host ids-tooltip {
  position: absolute;
}

:host(.outlined:hover),
:host(.outlined:focus),
:host(.outlined:focus-visible),
:host(.outlined:focus-within) {
  box-shadow: 0 0 3px 2px rgba(0, 114, 237, 0.3019607843);
  outline: 1px solid var(--ids-color-border-focus);
}

:host([disabled]) {
  opacity: 0.5;
}
:host([disabled]) .ids-color {
  cursor: default;
}

:host([clickable=false]) .ids-color {
  cursor: default;
}

:host([size=full]) .ids-color {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
:host([size=full]) {
  width: 100%;
}

.ids-color {
  background-color: var(--ids-color-neutral-100);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
}
.ids-color.xs {
  height: 18px;
  min-width: 18px;
  width: 18px;
}
.ids-color.sm {
  height: 20px;
  min-width: 20px;
  width: 20px;
}
.ids-color.mm {
  height: 22px;
  min-width: 22px;
  width: 24px;
}
.ids-color.md {
  height: 32px;
  min-width: 32px;
  width: 32px;
}
.ids-color.lg {
  height: 42px;
  min-width: 42px;
  width: 42px;
}
.ids-color.full {
  height: 55px;
  margin: 8px 0 18px;
  width: 100%;
}
.ids-color ids-text {
  align-self: end;
  position: relative;
  top: 22px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: normal;
}

.color-check {
  color: var(--ids-color-white-100);
  opacity: 0;
}

:host(.light) .color-check {
  color: var(--ids-color-neutral-100);
}

:host([checked]) .color-check {
  opacity: 1;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
